import { RadioGroup_Field_default } from "./chunk-P5UKJNSA.js";
import { RadioGroup_default } from "./chunk-NLYV5NX4.js";
import { CheckableGroup_MoreButton_default } from "./chunk-TIZNBNQ3.js";

// src/components/RadioGroup/index.ts
var RadioGroupComponent = RadioGroup_default;
RadioGroupComponent.Field = RadioGroup_Field_default;
RadioGroupComponent.Field.displayName = "RadioGroup.Field";
RadioGroupComponent.MoreButton = CheckableGroup_MoreButton_default;
RadioGroupComponent.MoreButton.displayName = "RadioGroup.MoreButton";
export { RadioGroupComponent };